module.exports = __webpack_public_path__ + "fonts/UcCo3FwrK3iLTcvtYwYZ8UA3J58.86c12e3.woff2";